export default {
  NewsFeed: {
    Title: 'Bảng tin',
    Reply: 'Trả lời',
    UpcomingCalendar: 'Lịch học sắp tới',
    Exercise: 'Bài tập sắp đến hạn',
    Post: 'Đăng bài',
    Image: 'Hình ảnh',
    Attach: 'Đính kèm',
    Calendar: 'Lịch học',
    EnterContentPost: 'Nhập nội dung bài viết'
  }
}
